import { Heading as ChakraHeading } from "@chakra-ui/react";

const Heading = ({
	children,
	size,
	alignment = "left",
	className = "",
  mb = null,
  color = null
}) => {
	const headingSize =
		size === "h4"
			? { base: "md", md: "xl" }
			: size === "h3"
			? { base: "lg", md: "2xl" }
			: size === "h2"
			? { base: "xl", md: "3xl" }
			: size === "h1"
			? { base: "2xl", md: "4xl" }
      : size === "title"
      ? { base: "4xl", md: "title" }
			: null;
	return (
		<ChakraHeading
			as={size === "title" ? "h1" : size}
			size={headingSize}
      className={`${className} text-${alignment}`}
      mb={mb}
      color={color}
		>
			{children}
		</ChakraHeading>
	);
};

export default Heading;
